import { useCallback, useState } from "react";

export function useCenteredTree (defaultTranslate = { x: 0, y: 0 }){
  const [translate, setTranslate] = useState(defaultTranslate);
  const [dimensions, setDimensions] = useState();
  const containerRef = useCallback((containerElem) => {
    if (containerElem !== null) {
      const { width, height } = containerElem.getBoundingClientRect();
      setDimensions({ width, height });
      setTranslate({ x: width / 2, y: height / 10 });
    }
  }, []);
  return [dimensions, translate, containerRef];
};
  